import { get } from '../../../utils/api';
import { withUnauthorizedToken } from '../../../utils/auth';

export default {
  getApplePayDeliveryPrice: () =>
    get({ url: 'apple-pay/delivery-price', data: withUnauthorizedToken() }),
  getApplePayStatus: restaurant_id => get({ url: 'apple-pay/status', restaurant_id }),
};
